module.exports = __webpack_public_path__ + "img/germany-digestive-diseases-female.a1d9c894.png";